import { dashboardSummarySchema, type DashboardSummary } from '@gb-ticket/shared-types';
import { useQuery } from '@tanstack/react-query';

import { apiFetch } from '@/lib/api';

export const dashboardSummaryQueryKey = ['dashboard', 'summary'] as const;

const REFRESH_MS = 60_000;

export function useDashboardSummary(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: dashboardSummaryQueryKey,
    enabled: options?.enabled ?? true,
    refetchInterval: REFRESH_MS,
    queryFn: (): Promise<DashboardSummary> =>
      apiFetch('/dashboard/summary', dashboardSummarySchema),
  });
}
